export default __webpack_public_path__ + "static/media/check.057bf0d7.svg";